import { render } from "./authorityTransferView.vue?vue&type=template&id=c5214e80&scoped=true&ts=true"
import script from "./authorityTransferView.vue?vue&type=script&lang=ts"
export * from "./authorityTransferView.vue?vue&type=script&lang=ts"

import "./authorityTransferView.vue?vue&type=style&index=0&id=c5214e80&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5214e80"]])

export default __exports__